import { render, staticRenderFns } from "./SessionData.vue?vue&type=template&id=6515fcfe&scoped=true&"
import script from "./SessionData.vue?vue&type=script&lang=js&"
export * from "./SessionData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6515fcfe",
  null
  
)

export default component.exports